import { apiClient } from "@/shared/api/client";
import {
  DownloadableContent,
  DownloadableContentResponse,
  DownloadUrlResponse,
} from "@/entities/downloadable-content";

const BASE_URL = "v1/downloadable-content";

/**
 * 모든 다운로드 가능한 콘텐츠 조회
 */
export const fetchAllDownloadableContent = async (
  active?: boolean
): Promise<DownloadableContent[]> => {
  const params = active !== undefined ? `?active=${active}` : "";
  const response = await apiClient.get<DownloadableContentResponse>(
    `${BASE_URL}${params}`
  );
  return response.data.data;
};

/**
 * 활성 콘텐츠만 조회
 */
export const fetchActiveDownloadableContent = async (): Promise<
  DownloadableContent[]
> => {
  return fetchAllDownloadableContent(true);
};

/**
 * 단일 콘텐츠 조회
 */
export const fetchDownloadableContentById = async (
  id: string
): Promise<DownloadableContent> => {
  const response = await apiClient.get<DownloadableContentResponse>(
    `${BASE_URL}/${id}`
  );
  return response.data.data[0];
};

/**
 * 파일 다운로드 URL 생성
 */
export const getDownloadUrl = async (id: string): Promise<string> => {
  const response = await apiClient.get<DownloadUrlResponse>(
    `${BASE_URL}/${id}/download-url`
  );
  return response.data.data.url;
};

/**
 * 썸네일 다운로드 URL 생성
 */
export const getThumbnailDownloadUrl = async (id: string): Promise<string> => {
  const response = await apiClient.get<DownloadUrlResponse>(
    `${BASE_URL}/${id}/thumbnail-download-url`
  );
  return response.data.data.url;
};
